import { UserAdmin } from "@/types";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../reducer";

export interface AccountState {
  account: UserAdmin;
}

export const initialState: AccountState = {
  account: new UserAdmin(),
};

export const accountSlice = createSlice({
  name: "account",
  initialState,
  reducers: {
    setInfoAccount: (state, { payload }: PayloadAction<UserAdmin>) => {
      state.account = payload;
    },
  },
});

export const sliceActions = accountSlice.actions;
export const accountReducer = accountSlice.reducer;
export const accountSelector = (state: RootState) => state.account;
